import React from 'react'
import EyefinitySectionFields from '../EyefinitySectionFields'

export default function ContactLens(props) {

  return <EyefinitySectionFields {...props} sectionName="contact_lens" title="Contact Lens" />
}
